import React from 'react';
import PropTypes from 'prop-types';
import styled from "styled-components";
import {AgGridColumn as Col, AgGridReact as Grid} from "ag-grid-react";

import {DangerButton, FileUploader, PageSection, DateRenderer} from "../../../components";

const Container = styled.div`
    width: 100%;
    height: 425px;
`;

const StyledFileUploader = styled(FileUploader)`
  margin-bottom: 1rem;
`;

class Documentation extends React.Component {

  deleteFile = doc => () => this.props.onDelete(doc);
  onFileClick = (doc) => (e) => {
    e.preventDefault();
    this.props.onFileClick(doc);
  };

  actions = ({data}) => {
    const enabled = this.canUploadAndDelete();
    return enabled ? (<div>
      <DangerButton onClick={this.deleteFile(data)}>Delete</DangerButton>
    </div>) : null;
  }

  fileNameRenderer = ({data}) => (<div>
    <a href={data.url} onClick={this.onFileClick(data)}>{data.fileName}</a>
  </div>);

  onGridReady = ({api}) => api.sizeColumnsToFit();

  canUploadAndDelete = () => {
    const {record, roles} = this.props;
    return roles.admin || record.recordStatusValue < 3;
  };

  render() {
    const canUploadAndDelete = this.canUploadAndDelete();
    const {documentation, onUpload} = this.props;
    return (
      <PageSection title="PASRR Documentation">
        {canUploadAndDelete && <StyledFileUploader onUpload={onUpload} fileTypes={['pdf', 'doc', 'docx', 'xls', 'xlsx']}/>}
        <Container className='ag-fresh'>
          <Grid
            rowData={documentation}
            onGridReady={this.onGridReady}
            paginationPageSize={10}
            pagination={true}
            enableFilter={true}
            enableSorting={true}
            suppressMovableColumns={true}
            headerHeight={35}
            rowHeight={35}
            enableColResize={true}
            defaultColDef={{filterParams: {newRowsAction: 'keep'}}}
            columnTypes={{
              actionsColumn: {suppressMenu: true, suppressSorting: true}
            }}
            frameworkComponents={{
              fileNameRenderer: this.fileNameRenderer,
              actionsRenderer: this.actions,
              dateRenderer: DateRenderer
            }}
          >
            <Col
              headerName="File Name"
              field="fileName"
              cellRenderer="fileNameRenderer"
            />
            <Col 
              width={40}
              headerName="Upload Date"
              field="dateCreated"
              cellRenderer="dateRenderer"
            />
            <Col
              width={20}
              headerName="Actions"
              type="actionsColumn"
              cellRenderer="actionsRenderer"
            />
          </Grid>
        </Container>
      </PageSection>
    );
  }
}

Documentation.propTypes = {
  record: PropTypes.object.isRequired,
  roles: PropTypes.shape({
    admin: PropTypes.bool.isRequired,
    nursingFacility: PropTypes.bool.isRequired,
  }).isRequired,
  documentation: PropTypes.array.isRequired,
  onUpload: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onFileClick: PropTypes.func.isRequired,
};

export default Documentation;



// WEBPACK FOOTER //
// ./src/modules/record/components/Documentation.js